module.exports = __webpack_public_path__ + "img/back.e8365580.png";